import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../lib/api';

const AuthContext = createContext();

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};

export const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(() => localStorage.getItem('wayside-admin-token'));
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const verifyToken = async () => {
            if (token) {
                try {
                    await axios.get(`${API}/admin/me`, {
                        headers: { Authorization: `Bearer ${token}` }
                    });
                    setIsAuthenticated(true);
                } catch {
                    localStorage.removeItem('wayside-admin-token');
                    setToken(null);
                    setIsAuthenticated(false);
                }
            }
            setLoading(false);
        };
        verifyToken();
    }, [token]);

    const login = async (username, password) => {
        const response = await axios.post(`${API}/admin/login`, { username, password });
        const newToken = response.data.access_token;
        localStorage.setItem('wayside-admin-token', newToken);
        setToken(newToken);
        setIsAuthenticated(true);
        return true;
    };

    const logout = () => {
        localStorage.removeItem('wayside-admin-token');
        setToken(null);
        setIsAuthenticated(false);
    };

    const getAuthHeaders = () => ({
        Authorization: `Bearer ${token}`
    });

    return (
        <AuthContext.Provider value={{
            token,
            isAuthenticated,
            loading,
            login,
            logout,
            getAuthHeaders
        }}>
            {children}
        </AuthContext.Provider>
    );
};
